<template>
  <div>
    <section
      class="ct-online-casino mb-24"
      :style="{
        'background-color': $root.color_schema.primary,
      }"
    >
      <div
        :class="{ 'container editor-content pb-25': true, 'pt-20': heightVal }"
        id="pt"
      >
        <template
          v-if="usmapData && usmapData.heading && usmapData.heading != ''"
        >
          <TagBlock
            :attrs="usmapData"
            :title="usmapData.heading"
            :block="'usBlock'"
            :usTag="
              usmapData && usmapData.heading_tag
                ? usmapData.heading_tag
                : 'span'
            "
            :sty="true"
          />
        </template>
        <template
          v-if="
            usmapData && usmapData.sub_heading && usmapData.sub_heading != ''
          "
        >
          <TagBlock
            :attrs="usmapData"
            :title="usmapData.sub_heading"
            :block="'usBlock'"
            :usTag="
              usmapData && usmapData.subheading_tag
                ? usmapData.subheading_tag
                : 'span'
            "
            :sty="true"
          />
        </template>
        <template v-if="usmapData.selected_map === 'US'">
          <svg
            viewBox="0 0 959 593"
            width="1240"
            height="767"
            class="svg-states"
          >
            <g id="states">
              <path
                v-for="state in states"
                :key="state.state_code"
                :id="state.state_code"
                @mouseover="setInfoBoxPosition"
                @mousemove="moveOnLocation"
                :fill="getFillColor(state.age_casinos)"
                :d="state.d"
                :data-name="state.state_code"
                :data-age="state.age_casinos"
              />
            </g>
          </svg>
        </template>
        <template v-else-if="usmapData.selected_map === 'NL'">
          <svg
            viewBox="0 0 559 753"
            width="1240"
            height="767"
            class="svg-states"
          >
            <g id="states">
              <path
                v-for="state in states"
                :key="state.state_code"
                :id="state.state_code"
                :title="state.state_name"
                @mouseover="setInfoBoxPosition"
                @mousemove="moveOnLocation"
                :fill="getFillColor(state.age_casinos)"
                :d="state.d"
                :data-name="state.state_code"
                :data-age="state.age_casinos"
              />
            </g>
          </svg>
        </template>
        <div class="map__legend">
          <span class="map__legend-group">
            <span
              class="map__legend-color map__legend-color--green"
              :style="{
                background: usmapData.colors ? usmapData.colors.color_18 : null,
              }"
            ></span>
            <span
              :class="{
                'map__legend-age': true,
                'text-white': !getContrastYIQ($root.color_schema.primary),
                'text-gray': getContrastYIQ($root.color_schema.primary),
              }"
              >18</span
            >
          </span>
          <span class="map__legend-group">
            <span
              class="map__legend-color map__legend-color--yellow"
              :style="{
                background: usmapData.colors ? usmapData.colors.color_20 : null,
              }"
            ></span>
            <span
              :class="{
                'map__legend-age': true,
                'text-white': !getContrastYIQ($root.color_schema.primary),
                'text-gray': getContrastYIQ($root.color_schema.primary),
              }"
              >20</span
            >
          </span>
          <span class="map__legend-group">
            <span
              class="map__legend-color map__legend-color--purple"
              :style="{
                background: usmapData.colors ? usmapData.colors.color_21 : null,
              }"
            ></span>
            <span
              :class="{
                'map__legend-age': true,
                'text-white': !getContrastYIQ($root.color_schema.primary),
                'text-gray': getContrastYIQ($root.color_schema.primary),
              }"
              >21</span
            >
          </span>
          <span class="map__legend-group">
            <span
              class="map__legend-color map__legend-color--unset"
              :style="{
                background: usmapData.colors ? usmapData.colors.color_na : null,
              }"
            ></span>
            <span
              :class="{
                'map__legend-age': true,
                'text-white': !getContrastYIQ($root.color_schema.primary),
                'text-gray': getContrastYIQ($root.color_schema.primary),
              }"
              >{{ $root.i18n.n_a }}</span
            >
          </span>
        </div>
        <div
          class="map__tooltip"
          id="js-map-tooltip"
          v-show="stateLegalStatus"
          :style="infoPosition"
        >
          <div
            class="map__tooltip-state"
            :data-age="$root.selectedState.age_casinos"
            :style="{ color: getFillColor($root.selectedState.age_casinos) }"
          >
            {{ $root.selectedState.state_name }}
          </div>
          <div class="map__tooltip-age">
            {{ $root.i18n.legal_age }}:
            <span class="map__tooltip-age map__tooltip-age--suffix">{{
              $root.selectedState.age_casinos
            }}</span>
          </div>
          <template v-if="$root.selectedState.url">
            <a
              :title="$root.selectedState.state_name"
              :href="$root.selectedState.url"
              class="cta cta-primary custom-btn map__tooltip-button"
              :style="{
                '--primary-btn': $root.color_schema.primary_btn,
                '--primary-btn-hover': pSBC(
                  -0.2,
                  $root.color_schema.primary_btn
                ),
              }"
              >{{ $root.i18n.best_casinos_in }}
              {{ $root.selectedState.state_name }}</a
            >
            <!--<template
              v-if="$root.selectedState.partner && $root.selectedState.url"
            >
              <a :href="$root.selectedState.url">
                <div class="map__tooltip-controls">
                  <span class="map__tooltip-divider"></span>
                  <div class="map__tooltip-image">
                    <img
                      :src="$root.selectedState.partner.logo"
                      :alt="$root.selectedState.partner.name"
                      data-nolazy
                    />
                  </div>
                  <div class="map__tooltip-affiliate">
                    <div class="map__tooltip-name">
                      {{ $root.selectedState.partner.name }}
                    </div>
                    <div class="map__tooltip-badge badge badge--choice">
                      <span class="badge__text">{{
                        $root.i18n.top_choice
                      }}</span>
                    </div>
                  </div>
                </div>
              </a>
            </template>-->
          </template>
          <p class="map__tooltip-error" v-else>
            {{
              $root.i18n.sorry_there_are_no_casinos_available_in_this_state_yet
            }}.
          </p>
        </div>
      </div>
    </section>
    <div class="container" v-if="usmapData && usmapData.enable_table_data">
      <div class="editor-content">
        <section class="ct-online-table mb-24">
          <template
            v-if="
              usmapData &&
              usmapData.table_heading &&
              usmapData.table_heading != ''
            "
          >
            <TagBlock
              :attrs="usmapData"
              :title="usmapData.table_heading"
              :block="'usBlock'"
              :usTag="
                usmapData && usmapData.table_heading_tag
                  ? usmapData.table_heading_tag
                  : 'span'
              "
              :sty="false"
            />
          </template>
          <table class="flex-table">
            <thead>
              <tr>
                <th>
                  <span>{{ $root.i18n.us_states }}</span>
                </th>
                <th>
                  <span>{{ $root.i18n.casinos }}</span>
                </th>
                <th>
                  <span>{{ $root.i18n.poker_rooms }}</span>
                </th>
                <th>
                  <span>{{ $root.i18n.bingo }}</span>
                </th>
                <th>
                  <span>{{ $root.i18n.lottery }}</span>
                </th>
                <th>
                  <span>{{ $root.i18n.dog_horse_racing }}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <div v-for="(stateList, index) in stateTopList" :key="index">
                <template v-if="index <= currentListIndex">
                  <transition-group name="fade" tag="div" appear>
                    <tr v-for="state in stateList" :key="state.state_code">
                      <td>
                        <a :title="state.state_name" :href="state.url">{{
                          state.state_name
                        }}</a>
                      </td>
                      <td>{{ state.age_casinos_lbl }}</td>
                      <td>{{ state.age_poker_rooms_lbl }}</td>
                      <td>{{ state.age_bingo_lbl }}</td>
                      <td>{{ state.age_lottery_lbl }}</td>
                      <td>{{ state.age_dog_horse_racing_lbl }}</td>
                    </tr></transition-group
                  ></template
                >
              </div>
            </tbody>
          </table>
          <template
            v-if="
              currentListIndex < stateTopList.length - 1 &&
              Object.keys(usmapData.states_data).length > stateDefaultDisplay
            "
          >
            <div class="col-md-12 text-center ct-card-grp">
              <a
                :title="$root.i18n.load_more_states"
                @click="++currentListIndex"
                class="
                  cta cta-secondary cta-promotion cta-large cta-lg-br
                  custom-btn-clr
                "
                :style="{ '--primary-btn': $root.color_schema.primary_btn }"
              >
                {{ $root.i18n.load_more_states }}
              </a>
            </div>
          </template>
          <template
            v-if="
              currentListIndex === stateTopList.length - 1 &&
              Object.keys(usmapData.states_data).length > stateDefaultDisplay
            "
          >
            <div class="col-md-12 text-center ct-card-grp">
              <a
                :title="$root.i18n.load_less_states"
                @click="currentListIndex = 0"
                class="
                  cta cta-secondary cta-promotion cta-large cta-lg-br
                  custom-btn-clr
                "
                :style="{ '--primary-btn': $root.color_schema.primary_btn }"
              >
                {{ $root.i18n.load_less_states }}
              </a>
            </div>
          </template>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import { getCountryCode } from "@/misc/states";
import { pSBC, getContrastYIQ } from "@/misc/misc-function";
import TagBlock from "@/components/custom-block/TagBlock";

export default {
  name: "USMap",
  props: ["usmapData", "heightVal"],
  components: {
    TagBlock,
  },
  data() {
    return {
      states: [],

      infoBoxPosition: {
        X: 0,
        Y: 0,
      },
      infoPosition: {
        display: "none",
      },
      currentListIndex: 0,
      stateDefaultDisplay: 0,
      stateTopList: [],
    };
  },
  computed: {
    stateLegalStatus: function () {
      return (
        typeof this.$root.selectedState.age_casinos === "string" &&
        this.$root.selectedState.age_casinos.length !== 0
      );
    },
    stateURL: function () {
      return (
        typeof this.$root.selectedState.url === "string" &&
        this.$root.selectedState.url.length !== 0
      );
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", () => {
      this.setInfoBoxPosition();
      this.moveOnLocation();
      let windowWidth = window.innerWidth;
      if (!this.smallCardView && windowWidth >= 768) {
        this.smallCardView = true;
      }
    });
    window.removeEventListener("mousemove", (e) => {
      if (e.target) {
        if (
          document.getElementById("js-map-tooltip") &&
          document.getElementById("js-map-tooltip").contains(e.target)
        ) {
        } else {
          this.unpointLocation(e);
        }
      }
    });
  },
  mounted() {
    this.states = getCountryCode(this.usmapData.selected_map);
    this.setStates();

    this.$nextTick(() => {
      //this.updateBonusHeight();
    });
    window.addEventListener("resize", () => {
      this.setInfoBoxPosition();
      this.moveOnLocation();
      let windowWidth = window.innerWidth;
      if (!this.smallCardView && windowWidth >= 768) {
        this.smallCardView = true;
      }
    });

    window.addEventListener("mousemove", (e) => {
      if (e.target) {
        if (
          document.getElementById("js-map-tooltip") &&
          document.getElementById("js-map-tooltip").contains(e.target)
        ) {
        } else {
          this.unpointLocation(e);
        }
      }
    });

    // StateList Section Data Extraction
    Array.prototype.eachSlice = function (size) {
      this.arr = [];
      for (var i = 0, l = this.length; i < l; i += size) {
        this.arr.push(this.slice(i, i + size));
      }
      return this.arr;
    };

    let offsetLength = parseInt(this.$root.display_offset); //this.attrs.hasOwnProperty("display_offset") ? parseInt(this.attrs.display_offset) : parseInt(this.$root.display_offset);
    this.stateDefaultDisplay = parseInt(this.$root.default_display);
    // this.attrs.hasOwnProperty("default_display")
    //   ? parseInt(this.attrs.default_display)
    //   : parseInt(this.$root.default_display);
    let stateDefaultArray = Object.values(this.usmapData.states_data).slice(
      0,
      this.stateDefaultDisplay
    );
    let stateRemainingArray = Object.values(this.usmapData.states_data).slice(
      this.stateDefaultDisplay
    );

    this.stateTopList = [
      stateDefaultArray,
      ...stateRemainingArray.eachSlice(offsetLength),
    ];
  },
  methods: {
    getContrastYIQ,
    pSBC,
    setStates: function () {
      this.states = this.states.map((state) => {
        if (this.usmapData) {
          if (this.usmapData.states_data[state.state_code]) {
            return {
              ...state,
              url: this.usmapData.states_data[state.state_code].url,
              age_casinos:
                this.usmapData.states_data[state.state_code].age_casinos,
              age_casinos_lbl:
                this.usmapData.states_data[state.state_code].age_casinos_lbl,
              age_poker_rooms:
                this.usmapData.states_data[state.state_code].age_poker_rooms,
              age_poker_rooms_lbl:
                this.usmapData.states_data[state.state_code]
                  .age_poker_rooms_lbl,
              age_bingo: this.usmapData.states_data[state.state_code].age_bingo,
              age_bingo_lbl:
                this.usmapData.states_data[state.state_code].age_bingo_lbl,
              age_lottery:
                this.usmapData.states_data[state.state_code].age_lottery,
              age_lottery_lbl:
                this.usmapData.states_data[state.state_code].age_lottery_lbl,
              age_dog_horse_racing:
                this.usmapData.states_data[state.state_code]
                  .age_dog_horse_racing,
              age_dog_horse_racing_lbl:
                this.usmapData.states_data[state.state_code]
                  .age_dog_horse_racing_lbl,
            };
          }
          return state;
        }
      });
    },
    setInfoBoxPosition: function (e) {
      if (window.innerWidth > 1024) {
        if (this.states.length > 1 && e && e.target) {
          this.states.forEach((state) => {
            if (
              state.state_code === e.target.getAttribute("data-name") &&
              e.target.getAttribute("data-age") != "N/A" &&
              e.target.getAttribute("data-age") != null
            ) {
              this.$root.selectedState = state;
            }
          });
        }
      } else {
        this.infoPosition = { display: "none" };
      }
    },
    getFillColor: function (age) {
      let status = {
        18:
          this.usmapData &&
          this.usmapData.colors &&
          Object.keys(this.usmapData.colors).length > 0
            ? this.usmapData.colors.color_18
            : null,
        "18-only-cruises":
          this.usmapData &&
          this.usmapData.colors &&
          Object.keys(this.usmapData.colors).length > 0
            ? this.usmapData.colors.color_18
            : null,
        "18-indian-casinos":
          this.usmapData &&
          this.usmapData.colors &&
          Object.keys(this.usmapData.colors).length > 0
            ? this.usmapData.colors.color_18
            : null,
        "18-21":
          this.usmapData &&
          this.usmapData.colors &&
          Object.keys(this.usmapData.colors).length > 0
            ? this.usmapData.colors.color_21
            : null,
        20:
          this.usmapData &&
          this.usmapData.colors &&
          Object.keys(this.usmapData.colors).length > 0
            ? this.usmapData.colors.color_20
            : null,
        21:
          this.usmapData &&
          this.usmapData.colors &&
          Object.keys(this.usmapData.colors).length > 0
            ? this.usmapData.colors.color_21
            : null,
        "N/A":
          this.usmapData &&
          this.usmapData.colors &&
          Object.keys(this.usmapData.colors).length > 0
            ? this.usmapData.colors.color_na
            : null,
        null:
          this.usmapData &&
          this.usmapData.colors &&
          Object.keys(this.usmapData.colors).length > 0
            ? this.usmapData.colors.color_null
            : null,
      };
      return status[age];
    },
    moveOnLocation: function (e) {
      if (window.innerWidth > 1024 && e && e.target) {
        this.states.forEach((state) => {
          if (
            state.state_code === e.target.getAttribute("data-name") &&
            e.target.getAttribute("data-age") != "N/A" &&
            e.target.getAttribute("data-age") != null
          ) {
            let tooltipArrowHeight = 8;
            let tooltipHeight =
              document.getElementById("js-map-tooltip").offsetHeight +
              tooltipArrowHeight;
            let tooltipWidth =
              document.getElementById("js-map-tooltip").offsetWidth;
            this.infoBoxPosition.Y = `${
              e.clientY -
              document.getElementById("pt").getBoundingClientRect().top -
              tooltipHeight
            }px`;
            this.infoBoxPosition.X = `${
              e.clientX -
              document.getElementById("pt").getBoundingClientRect().left
            }px`;
            this.infoPosition = {
              display: "block",
              transform: `translate(${this.infoBoxPosition.X}, ${this.infoBoxPosition.Y})`,
            };
            this.$root.pathValue = e.clientY;
          }
        });
      } else {
        this.infoPosition = { display: "none" };
      }
    },
    unpointLocation: function (e) {
      if (this.$root.pathValue === e.clientY) {
      } else {
        this.$root.selectedState = {};
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/less/base/variable";

.wd-100 {
  width: 100% !important;
}
.ct-online {
  &-casino {
    position: relative;
    clear: both;
    display: flex;
    align-items: center;
    width: 100%;
    //background: #060236;
    padding: 0 !important;
    margin-top: 0px;

    @media (min-width: @sizes[large]) {
      //padding: 0 75px 25px;
      //margin-top: 14px;
    }
  }
}

.mb-24 {
  margin-bottom: 24px;
}

.svg-states {
  display: block;
  width: 100%;
  height: 245px;
  margin-bottom: 24px;
  @media (min-width: @sizes[medium]) {
    margin-bottom: 36px;
    height: 460px;
  }
  @media (min-width: @sizes[large]) {
    height: 767px;
  }
}

.map__legend {
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  flex-direction: row;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  &-group {
    display: -webkit-box;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    flex-direction: row;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    margin-right: 16px;
    @media (min-width: @sizes[medium]) {
      margin-right: 56px;
    }
  }
  &-color {
    width: 12px;
    height: 12px;
    min-width: 12px;
    min-height: 12px;
    border-radius: 100%;
    @media (min-width: @sizes[medium]) {
      width: 23px;
      height: 23px;
      min-width: 23px;
      min-height: 23px;
    }
  }
  &-age {
    display: block;
    margin-left: 4px;
    font-weight: 700;
    font-size: 0.75rem;

    @media (min-width: @sizes[medium]) {
      margin-left: 10px;
      font-size: 1.5rem;
    }
  }
}

// .map__legend-color--green {
//   background: #58fba4;
// }

// .map__legend-color--yellow {
//   background: #fbbb40;
// }

// .map__legend-color--purple {
//   background: #891ec7;
// }

// .map__legend-color--unset {
//   background: #221d47;
// }

.map__tooltip {
  @media (min-width: @sizes[extra-large]) {
    display: -webkit-box;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    padding: 8px 12px 12px;
    width: 236px;
    min-width: 236px;
    height: auto;
    min-height: auto;
    background: #fff;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);
    position: absolute;
    left: -13px;
    top: 13px;
    z-index: 1;
    text-align: center;
    &-state {
      display: block;
      margin-bottom: 4px;
      line-height: 120%;
      font-size: 1.125rem;
      font-weight: 700;
      text-transform: uppercase;
      color: #221d47;
      .map__tooltip-state[data-age*="21"] {
        color: #891ec7;
      }
      .map__tooltip-state[data-age*="null"] {
        color: #fbbb40;
      }
      .map__tooltip-state[data-age*="18"] {
        color: #58fba4;
      }
    }
    &-age {
      display: inline-block;
      vertical-align: middle;
      line-height: 120%;
      font-weight: 700;
      text-align: center;
      color: #0a0433;
    }
    &-button {
      display: block;
      margin: 9px 0;
      padding: 0;
      width: 100%;
      min-width: 100%;
      height: 39px;
      min-height: 39px;
      line-height: 39px;
      font-size: 0.875rem;
      font-weight: 700;
      position: static;
    }
    .map__tooltip-age--suffix {
      font-weight: 400;
    }
    &::after {
      display: block;
      width: 0;
      height: 0;
      border-bottom: inset;
      content: "";
      border-color: transparent transparent #fff;
      border-style: inset inset solid;
      border-width: 0 20.5px 35.506px;
      position: absolute;
      z-index: -1;
      left: 0;
      bottom: -9px;
      -webkit-transform: matrix(-0.97, -0.28, 0.24, -0.96, 0, 0);
      transform: matrix(-0.97, -0.28, 0.24, -0.96, 0, 0);
    }
  }
}

.flex-table {
  display: flex;
  -webkit-box-direction: normal;
  -webkit-box-orient: vertical;
  flex-direction: column;
  -webkit-box-pack: start;
  justify-content: flex-start;
  -webkit-box-align: start;
  align-items: flex-start;
  width: 100%;
  overflow: hidden;
  @media (min-width: @sizes[small]) {
    display: inline-table;
  }
  thead {
    width: 100%;
    tr {
      background: #060033;
      color: @white;
      th {
        @media (max-width: @sizes[small]) {
          white-space: pre;
        }
      }
    }
  }
  tbody {
    width: 100%;
    tr {
      color: #373a3c;
      &:nth-child(odd) {
        background: #f3f3f3;
      }
      &:nth-child(even) {
        background: @white;
      }
      td {
        width: 33.33333%;
        min-width: 33.33333%;
        min-height: 39px;
        padding: 0 12px;
        line-height: 18px;
        font-size: 0.75rem;
        font-weight: 400;
        align-items: center;
        text-align: center;
        // medium
        @media (min-width: @sizes[medium]) {
          line-height: 26px;
          font-size: 1rem;
          width: 20%;
          min-width: 20%;
          min-height: 80px;
        }
        // tablet
        @media (min-width: @sizes[extra-large]) {
          line-height: 26px;
          font-size: 1.5rem;
          width: 16.66%;
          min-width: 16.66%;
        }
      }
      a {
        line-height: 160%;
        font-weight: 700;
        text-decoration: underline;
        display: inline;
        margin: auto;
        text-align: center;
      }
    }
  }
  tr {
    display: flex;
    -webkit-box-direction: normal;
    border-radius: 15px;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
    -webkit-box-orient: horizontal;
    flex-direction: row;
    -webkit-box-pack: justify;
    justify-content: space-between;
    align-content: center;
  }
  th,
  td {
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    flex-direction: row;
    -webkit-box-pack: center;
    justify-content: center;
    align-content: center;
    width: 33.33333%;
    min-width: 33.33333%;
    min-height: 39px;
    // medium
    @media (min-width: @sizes[medium]) {
      width: 20%;
      min-width: 20%;
      min-height: 83px;
    }
    // tablet
    @media (min-width: @sizes[extra-large]) {
      width: 16.66%;
      min-width: 16.66%;
      min-height: 83px;
    }
  }
  th {
    span {
      display: flex;
      -webkit-box-orient: horizontal;
      -webkit-box-direction: normal;
      flex-direction: row;
      -webkit-box-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      align-items: center;
      padding: 0 20px;
      line-height: 17px;
      font-size: 0.875rem;
      font-weight: 700;
      // tablet
      @media (min-width: 1024px) {
        line-height: 26px;
        font-size: 1.5rem;
      }
      // medium
      @media (min-width: 768px) {
        line-height: 26px;
        font-size: 1.375rem;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/custom-block/USMap.vue